import Icon from '../images/ico_exclamation.svg';
import { useSelector } from "react-redux";

export default function SelectedPreview(props) {
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);

  const characters = [];

  props.selectedCharacter.forEach((el, index) => {
    if (el === '') return;

    let filepath;

    props.CharacterList.forEach((char, i) => {
      if (i === el) {
        filepath = '/character_plain/' + char.filename + '.png';
      }
    });

    characters.push(
      <div className="selected-preview__character" onClick={removeCharacter} key={index} data-index={el}>
        <img
          src={filepath}
          alt={el}
          data-index={el}
        />
      </div>
    );
  });

  function removeCharacter(e) {
    console.log(e.target.dataset)
    props.removeCharacter(Number.parseInt(e.target.dataset.index));
  }


  return (
    <>
      <div className="selected-preview">
        {props.fewerFlag && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            {props.lang === 'ja' ? 'キャラクターを3体以上選択してください' : 'Please select at least 3 Character.'}
          </div>
        )}
        {props.message && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            {props.message}
          </div>
        )}
        {data.phase === '1' && !data.whitelisted && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            {props.lang === 'ja' ? 'WLに登録されていません' : 'You are not on the white list.'}
          </div>
        )}
        {/* {data.loaded && data.phase === '0' && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            Sale 11:00, Feb 25, 2023 (JST)
          </div>
        )} */}
        {blockchain.errorMsg !== "" && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            {blockchain.errorMsg === "Change network to Ethereum Mainnet." && props.lang === 'ja' ? 'Ethereum Goerliテストネットに切り替えてください' : (blockchain.errorMsg === 'Reload the browser.' && props.lang === 'ja' ? 'ブラウザをリロードしてください' : blockchain.errorMsg)}
          </div>
        )}
        {(blockchain.account === "" || blockchain.smartContract === null) && (
          <div className="selected-preview__alert">
            <img src={Icon} alt="!" />
            {props.lang === 'ja' ? '最初に、右上の WALLET CONNECT から Ethereum ウォレットへ接続！' : 'First, connect your Ethereum wallet from the WALLET CONNECT in the top right corner.'}
          </div>
        )}

        <div className="selected-preview__characters">{characters}</div>
      </div>
    </>
  );
}

